<template>
  <div class="resp">
    <div class="item">返回时间：{{result.time}}</div>
    <div v-if="result.resStatus.sucess">
      <p class="success">接口请求成功，状态码：{{ result.resStatus.status }}</p>
      <pre class="respBody">{{ result.resStatus.resp }}</pre>
    </div>
    <div class="error" v-if="result.resStatus.status !== 200">
      <p>接口请求失败，状态码：{{ result.resStatus.status }}</p>
      <pre class="respBody">{{ result.resStatus.resp }}</pre>
    </div>
    <div class="error" v-if="result.errorMsg !== ''">
      {{ result.errorMsg }}
    </div>
  </div>
</template>
<script>

export default {
  props: {
    result: {
      type: Object,
      default: () => ({
        errorMsg: "",
        resStatus: {
          status: 200,
          sucess: false,
          resp: "",
        },
        time:""
      }),
    },
  },
};
</script>
<style scoped>
.btn {
  height: 40px;
  padding: 0;
}
.resp {
  height: 100%;
  overflow: auto;
  padding:10px;
}
.respBody {
  padding: 10px;
  border-radius: 5px;
}
.error {
  color: red;
}
.success {
  color: green;
}
</style>